<app-infobox-table [data]="computeInfoboxData()"></app-infobox-table>
